import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Icon, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';
import { useLocation, useNavigate } from "react-router-dom";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import Loading from "components/Loading";
import { useGetBySubCategoryIdQuery, useDeleteChapterMutation, useReorderChaptersMutation } from "App/services/chapterServiceApi";
import ChapterFormDialog from "./components/chapterFormDialogue";
import EditChapterFormDialogue from "./components/chapterEditFormDialogue";
import useReorder from "components/Reorder/useReorder";
import ReorderableTableRow, { DragColumnHeader } from "components/Reorder/ReorderableTableRow";
import useFeatureEnabled from "components/FeatureToggle/useFeatureEnabled";

const useAllChapterData = (data) => {

  // const allSubCategoryQuery = useGetAllSubCategoryQuery({ refetchOnFocus: false });
  const byCatIdQuery = useGetBySubCategoryIdQuery(data, { refetchOnFocus: false });

  const [result, setResult] = useState({
    data: null,
    isLoading: true,
    isError: false,
    error: null,
    refetch: () => {},
  });

  useEffect(() => {
    if (data !== null) {
      setResult({
        data: byCatIdQuery.data,
        isLoading: byCatIdQuery.isLoading,
        isError: byCatIdQuery.isError,
        error: byCatIdQuery.error,
        refetch: byCatIdQuery.refetch,
      });
    }

    // } else {
    //   setResult({
    //     data: allSubCategoryQuery.data,
    //     isLoading: allSubCategoryQuery.isLoading,
    //     isError: allSubCategoryQuery.isError,
    //     error: allSubCategoryQuery.error,
    //   });
    // }
  }, [data, byCatIdQuery]);

  return result;
};

function Chapter() {
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const dragDropEnabled = useFeatureEnabled("drag_drop_reorder");
  const navigate = useNavigate();
  const location = useLocation();


  const data = location.state || {};

  const { data: chapters, isLoading, isFetching, isError, error, refetch } = useAllChapterData(data.data);


  const [deleteChapter] = useDeleteChapterMutation();
  const [reorderChapters] = useReorderChaptersMutation();

  const { ordered: sortedChapters, handleDragStart, handleDragOver, handleDrop } = useReorder(
    chapters,
    (ids) => reorderChapters({ subCategoryId: data.data, orderedIds: ids }).catch((err) => console.log(err))
  );

  if (isLoading || isFetching) {
    return <Loading />;
  }

  const handleClose = () => {
    setOpen(false);

  };


  // Delete Botton and Delete Dialog Box work


  const handleDeleteChapter = async () => {

    try {

      await deleteChapter(deleteId).unwrap();
      setDeleteDialogOpen(false);
      setDeleteId(null);
      
      if (chapters.length === 1) {
        window.location.reload(); 
      } else {
        
        refetch();
      }

    } catch (error) {

      console.error("Failed to delete chapter:", error);
    }
  };

  const handleDeleteConfirmation = (chapterId) => {
    setDeleteId(chapterId);
    setDeleteDialogOpen(true);
  };



  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteId(null);
  };

   // Chapter Id navigate to Question

  const handleNavigateQuestion = async (chapterId, categoryId) => {
   
    navigate('/question', { state: { data: chapterId, categoryId } });
  }

    // Pagination System


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return ( chapters ?

        // check subcategory under any chapter show
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Chapter
                </MDTypography>
                <ChapterFormDialog />
              </MDBox>
              <TableContainer>
                <Table>
                  <TableHead >
                    <TableRow>
                      <DragColumnHeader enabled={dragDropEnabled} />
                      <TableCell>Name</TableCell>
                      <TableCell sx={{textAlign:'right', paddingRight:20}}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? sortedChapters && sortedChapters.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : sortedChapters
                    ).map((chapter) => (

                      <ReorderableTableRow
                        key={chapter.id}
                        id={chapter.id}
                        dragEnabled={dragDropEnabled}
                        onDragStart={handleDragStart}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}
                      >
{/* {console.log(chapter)} */}
                        <TableCell sx={{ textAlign: 'left', textDecorationLine:'underline', cursor:'pointer', '&:hover': {color: 'blue'} }} onClick={() => handleNavigateQuestion(chapter.id, chapter.cat_id)} >{chapter.name}</TableCell>
                        <TableCell sx={{textAlign:'right', paddingRight:17}}>
                          <Tooltip title="Edit">
                            <span>
                              <EditChapterFormDialogue chapter={chapter} />
                            </span>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton aria-label="delete" onClick={() => handleDeleteConfirmation(chapter.id)}>
                              <Icon>delete</Icon>
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </ReorderableTableRow>
                    ))}
                  </TableBody>

                  {/* pagination */}

                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={dragDropEnabled ? 3 : 2}
                        count={sortedChapters.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        // ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}

         {/* Delete Dialog Box Open */}

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        sx={{textAlign:'center'}}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Are you sure you want to delete this chapter along with all questions?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteChapter} style={{ color: 'red' }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout> 
    :

        // not Available any chapter show only Head components 
    <DashboardLayout>
    <DashboardNavbar />
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <MDTypography variant="h6" color="white">
                Chapter
              </MDTypography>
              <ChapterFormDialog />
            </MDBox>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell sx={{ textAlign: "left" }} >Action</TableCell>
                  </TableRow>
                </TableHead>
                
                <TableFooter>
                </TableFooter>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
    {/* <Footer /> */}
  
  </DashboardLayout>
  );
}

export default Chapter;
